import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { bool, func, string } from 'prop-types'
import Modal from '@ui/component/Modal'
import Div from '@ui/layout/Div'
import ScanPhotoBox from './ScanPhotoBox'
import { useEffect } from 'react'
import { get } from '@util/xhrAPI'
import { updateCallsScanPhotos } from "@store/slice/sterilizationSlice"

const ScanPhotosModal = ({ isModalActive, toggleModal, photoFilter }) => {
  const { activeRowCall, callsScanPhotos } = useSelector(state => state.sterilization)
  const { mission } = useSelector(state => state.main)
  const dispatch = useDispatch()

  const { photos } = activeRowCall.scansData
  const [t] = useTranslation('sterilization')

  const generateScanPhotos = () => {
    const scanPhotos = Object.values(photos)
    if (scanPhotos.length) {
      return scanPhotos.map(photo => {
        if (photo[photoFilter]) {
          return <ScanPhotoBox scannedPhoto={photo} key={`scan-photo-${photo.id}`} />
        }
      })
    }
  }

  useEffect(() => {
    if (activeRowCall && !callsScanPhotos[activeRowCall.id]) {
      get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/${activeRowCall.id}/scan-photos`, response => {
        const { code, scanPhotos } = response
        if (200 === code) {
          dispatch(updateCallsScanPhotos({ [activeRowCall.id]: [...scanPhotos] }))
        }
      })
    }
  }, [activeRowCall])

  return (
    <Modal cssClass='scan-photos-modal' isActive={isModalActive} closeCallback={toggleModal} closeAction={true}>
      <h3>{t('titles.scan_photos_modal')}</h3>
      <Div cssClass="columns is-multiline">
        {generateScanPhotos()}
        <ScanPhotoBox initObject={{ scan: photoFilter }} />
      </Div>
    </Modal>
  )
}

ScanPhotosModal.propTypes = {
  isModalActive: bool,
  photoFilter: string,
  toggleModal: func
}

export default ScanPhotosModal